/*!
 * Color mode toggler for Bootstrap's
 */

// Only activate dark mode toggle if enabled in theme options
if (document.body.getAttribute('data-dark-mode') === 'enabled') {
  (() => {
    'use strict'

    const getStoredTheme = () => localStorage.getItem('theme')
    const setStoredTheme = theme => localStorage.setItem('theme', theme)

    const getPreferredTheme = () => {
      const storedTheme = getStoredTheme()
      if (storedTheme) {
        return storedTheme
      }

      return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
    }

    const setTheme = theme => {
      if (theme === 'auto') {
        document.documentElement.setAttribute('data-bs-theme', (window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'))
      } else {
        document.documentElement.setAttribute('data-bs-theme', theme)
      }
    }

    setTheme(getPreferredTheme())

    const showActiveTheme = (theme, focus = false) => {
      const themeSwitcher = document.querySelector('#bd-theme')

      if (!themeSwitcher) {
        return
      }

      const themeSwitcherText = document.querySelector('#bd-theme-text')
      const activeThemeIcon = document.querySelector('.theme-icon-active use')
      const btnToActive = document.querySelector(`[data-bs-theme-value="${theme}"]`)

      document.querySelectorAll('[data-bs-theme-value]').forEach(element => {
        element.classList.remove('active')
        element.setAttribute('aria-pressed', 'false')
      })

      btnToActive.classList.add('active')
      btnToActive.setAttribute('aria-pressed', 'true')
      const themeSwitcherLabel = `${themeSwitcherText.textContent} (${btnToActive.dataset.bsThemeValue})`
      themeSwitcher.setAttribute('aria-label', themeSwitcherLabel)

      if (focus) {
        themeSwitcher.focus()
      }
    }

    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', () => {
      const storedTheme = getStoredTheme()
      if (storedTheme !== 'light' && storedTheme !== 'dark') {
        setTheme(getPreferredTheme())
      }
    })

    window.addEventListener('DOMContentLoaded', () => {
      showActiveTheme(getPreferredTheme())

      document.querySelectorAll('[data-bs-theme-value]')
        .forEach(toggle => {
          toggle.addEventListener('click', () => {
            const theme = toggle.getAttribute('data-bs-theme-value')
            setStoredTheme(theme)
            setTheme(theme)
            showActiveTheme(theme, true)
          })
        })
    })
  })()
}

// Navbar scroll behavior and responsive content movement
document.addEventListener('DOMContentLoaded', () => {
  // Navbar hide/show on scroll
  let lastScrollTop = 0;
  const navbar = document.getElementById('st-navbar');

  if (navbar) {
    window.addEventListener('scroll', () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > lastScrollTop && scrollTop > 80) {
        navbar.classList.add('st-navbar-hidden');
      } else {
        navbar.classList.remove('st-navbar-hidden');
      }

      lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
    });
  }

  // Move shared content between navbar and offcanvas for responsive
  const sharedContent = document.getElementById('sharedContent');
  const mobileSearchContainer = document.getElementById('mobileSearchContainer');
  const mobileSocialContainer = document.getElementById('mobileSocialContainer');

  function moveSharedContent() {
    const searchForm = document.getElementById('searchForm');
    const socialIcons = document.getElementById('socialIcons');

    if (window.innerWidth < 992) {
      // Move content into offcanvas for mobile
      if (searchForm && mobileSearchContainer && !mobileSearchContainer.contains(searchForm)) {
        mobileSearchContainer.appendChild(searchForm);
      }
      if (socialIcons && mobileSocialContainer && !mobileSocialContainer.contains(socialIcons)) {
        mobileSocialContainer.appendChild(socialIcons);
      }
    } else {
      // Move content back into navbar for desktop
      if (sharedContent) {
        if (searchForm && !sharedContent.contains(searchForm)) {
          sharedContent.appendChild(searchForm);
        }
        if (socialIcons && !sharedContent.contains(socialIcons)) {
          sharedContent.appendChild(socialIcons);
        }
      }
    }
  }

  // Run on load and on window resize
  if (sharedContent && mobileSearchContainer && mobileSocialContainer) {
    moveSharedContent();
    window.addEventListener('resize', moveSharedContent);
  }
});